/**
 * PlusIcon — sanitized from `assets/newSvg/plus.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function PlusIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M2.5,12 C2.5,11.1716 3.17157,10.5 4,10.5 L20,10.5 C20.8284,10.5 21.5,11.1716 21.5,12 C21.5,12.8284 20.8284,13.5 20,13.5 L4,13.5 C3.17157,13.5 2.5,12.8284 2.5,12 Z"
        fill={color}
      />
      <Path
        d="M12,2.5 C12.8284,2.5 13.5,3.17157 13.5,4 L13.5,20 C13.5,20.8284 12.8284,21.5 12,21.5 C11.1716,21.5 10.5,20.8284 10.5,20 L10.5,4 C10.5,3.17157 11.1716,2.5 12,2.5 Z"
        fill={color}
      />
    </Svg>
  );
}

export default PlusIcon;
